__turbopack_context__.v({
  "slider": "Slider-module__DT1QyW__slider",
});
